var _desc, _defs, _g;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgChart2Cars(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: "36px",
    height: "35px",
    viewBox: "0 0 36 35",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title === undefined ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, "Group 5") : title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Created with Sketch.")), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("rect", {
    id: "path-1",
    x: 0,
    y: 0.5,
    width: 30,
    height: 30,
    rx: 8
  }), /*#__PURE__*/React.createElement("filter", {
    x: "-16.7%",
    y: "-13.3%",
    width: "133.3%",
    height: "133.3%",
    filterUnits: "objectBoundingBox",
    id: "filter-2"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.06 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter2"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1.5,
    in: "shadowOffsetOuter2",
    result: "shadowBlurOuter2"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.1 0",
    type: "matrix",
    in: "shadowBlurOuter2",
    result: "shadowMatrixOuter2"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter2"
  }))), /*#__PURE__*/React.createElement("filter", {
    x: "-31.0%",
    y: "-43.3%",
    width: "161.9%",
    height: "186.7%",
    filterUnits: "objectBoundingBox",
    id: "filter-3"
  }, /*#__PURE__*/React.createElement("feOffset", {
    dx: 0,
    dy: 1,
    in: "SourceAlpha",
    result: "shadowOffsetOuter1"
  }), /*#__PURE__*/React.createElement("feGaussianBlur", {
    stdDeviation: 1,
    in: "shadowOffsetOuter1",
    result: "shadowBlurOuter1"
  }), /*#__PURE__*/React.createElement("feColorMatrix", {
    values: "0 0 0 0 0   0 0 0 0 0   0 0 0 0 0  0 0 0 0.1 0",
    type: "matrix",
    in: "shadowBlurOuter1",
    result: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMerge", null, /*#__PURE__*/React.createElement("feMergeNode", {
    in: "shadowMatrixOuter1"
  }), /*#__PURE__*/React.createElement("feMergeNode", {
    in: "SourceGraphic"
  }))))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Page-1",
    stroke: "none",
    strokeWidth: 1,
    fill: "none",
    fillRule: "evenodd"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Desktop-HD-Copy-11",
    transform: "translate(-562.000000, -615.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group-5",
    transform: "translate(565.000000, 616.000000)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Rectangle"
  }, /*#__PURE__*/React.createElement("use", {
    fill: "black",
    fillOpacity: 1,
    filter: "url(#filter-2)",
    xlinkHref: "#path-1"
  }), /*#__PURE__*/React.createElement("use", {
    fill: "#9F1853",
    fillRule: "evenodd",
    xlinkHref: "#path-1"
  })), /*#__PURE__*/React.createElement("g", {
    id: "car-side-solid",
    filter: "url(#filter-3)",
    transform: "translate(5.000000, 8.000000)",
    fill: "#FFFFFF",
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M5.62078125,2.14285714 L7.35,2.14285714 L7.35,5.35714286 L3.65203125,5.35714286 L4.64953125,2.81584821 C4.80703125,2.41071429 5.1909375,2.14285714 5.62078125,2.14285714 Z M8.925,5.35714286 L8.925,2.14285714 L11.589375,2.14285714 C11.9076562,2.14285714 12.2095312,2.29017857 12.4096875,2.54464286 L14.6146875,5.35714286 L8.925,5.35714286 Z M17.3315625,5.390625 L14.0503125,1.20535714 C13.453125,0.441964286 12.5475,0 11.589375,0 L5.62078125,0 C4.33125,0 3.17296875,0.800223214 2.6971875,2.01897321 L1.3321875,5.50446429 C0.55125,5.81919643 0,6.59263393 0,7.5 L0,11.25 C0,11.8426339 0.46921875,12.3214286 1.05,12.3214286 L2.14265625,12.3214286 C2.39203125,13.8415179 3.688125,15 5.25,15 C6.811875,15 8.10796875,13.8415179 8.35734375,12.3214286 L12.6426563,12.3214286 C12.8920313,13.8415179 14.188125,15 15.75,15 C17.311875,15 18.6079688,13.8415179 18.8573438,12.3214286 L19.95,12.3214286 C20.5307813,12.3214286 21,11.8426339 21,11.25 L21,9.64285714 C21,7.45982143 19.39875,5.65848214 17.3315625,5.390625 Z M17.2364063,12.3214286 C17.0198437,12.9441964 16.4357812,13.3928571 15.75,13.3928571 C15.0642187,13.3928571 14.4801562,12.9441964 14.2635937,12.3214286 C14.2045312,12.1540179 14.175,11.9732143 14.175,11.7857143 C14.175,10.8984375 14.8804687,10.1785714 15.75,10.1785714 C16.6195312,10.1785714 17.325,10.8984375 17.325,11.7857143 C17.325,11.9732143 17.2921875,12.1540179 17.2364062,12.3214286 Z M5.25,13.3928571 C4.56421875,13.3928571 3.98015625,12.9441964 3.76359375,12.3214286 C3.70453125,12.1540179 3.675,11.9732143 3.675,11.7857143 C3.675,10.8984375 4.38046875,10.1785714 5.25,10.1785714 C6.11953125,10.1785714 6.825,10.8984375 6.825,11.7857143 C6.825,11.9732143 6.7921875,12.1540179 6.73640625,12.3214286 C6.51984375,12.9441964 5.93578125,13.3928571 5.25,13.3928571 Z",
    id: "Shape"
  })))))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgChart2Cars);
export default __webpack_public_path__ + "static/media/chart2-cars.ab6152ee0d932cfb60e8b0baf26b27a7.svg";
export { ForwardRef as ReactComponent };